const KeenSlider = window.KeenSlider
const { setInitialised, useArrows } = window.BAO.Carousel.plugins

class ProductCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    document.addEventListener('nav:changed', () => {
      this.setupCarousel()
    })

    // Set up Mutation Observer
    this.observer = new MutationObserver((mutations, observer) => {
      // Check if the carousel is already setup
      if (!this.carousel) {
        const slide = document.querySelector(
          '[data-product-carousel-el="slide"]',
        )
        if (slide) {
          const parent = slide.closest('.sec-Section-hidden')
          if (parent) parent.classList.remove('sec-Section-hidden')

          // setting up the carousel BEFORE the element is visible causes issues
          this.carousel = this.setupCarousel()

          observer.disconnect() // Stop observing once the carousel is setup
        }
      }
    })

    // Observe body for changes
    this.observer.observe(document.body, { childList: true, subtree: true })
  }

  setupCarousel () {
    const slides = this.querySelector('[data-product-carousel-el="slides"]')

    return new KeenSlider(
      slides,
      {
        selector: '[data-product-carousel-el="slide"]',
        loop: false,
        mode: 'snap',
        rubberband: false,
        slides: {
          perView: 1.95,
          spacing: 5,
        },
        breakpoints: {
          '(min-width: 768px)': {
            slides: {
              perView: 3.2,
              spacing: 10,
            },
          },
          '(min-width: 901px)': {
            slides: {
              perView: 4,
              spacing: 10,
            },
          },
        },
      },
      [
        setInitialised(),
        useArrows({
          container: this.els?.arrows?.element,
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
      ],
    )
  }

  disconnectedCallback () {
    super.disconnectedCallback()

    // Disconnect observer when the element is removed
    this.observer.disconnect()
  }
}

if (!customElements.get('product-carousel')) {
  customElements.define('product-carousel', ProductCarousel)
}
